/**
 * Standard outer wrapper for CMS pages.
 * Provides consistent padding, max-width, and vertical spacing.
 * @param {{ children: React.ReactNode, className?: string }} props
 */
export default function PageShell({ children, className = '' }) {
  return (
    <div className={`space-y-6 ${className}`}>
      {children}
    </div>
  );
}
